/**
 * Formats an AcademicYearName like "2025-2026" or "2025-26" as the compact pill
 * label "2025–26" (en dash). Falls back to the raw name when unrecognized.
 */
export function academicYearPillLabel(yearName?: string): string {
    const match = yearName?.match(/^(\d{4})-(?:\d{2})?(\d{2})$/);
    return match ? `${match[1]}–${match[2]}` : (yearName ?? '');
}
